<template>
  <div class="rating-chart-legend-item">
    <div class="legend-serie">
      <div class="color-box" :style="{ backgroundColor: color }"></div>
      <StarsRating :rating="rating" />
    </div>

    <div class="rating-count-wrapper">
      <div class="rating-count">({{ countLabel }})</div>
    </div>
  </div>
</template>

<script>
import { RATING_CHART_COLOR } from "@/config/rating-chart-colors";
import { pluralCount } from "@/helpers/helpers";
import StarsRating from "@/components/ui/StarsRating";

export default {
  name: "ReviewsAnalystRatingsChartLegendItem",
  components: {
    StarsRating
  },
  props: {
    rating: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      required: true
    }
  },
  computed: {
    color() {
      return RATING_CHART_COLOR["RATING_" + this.rating];
    },
    countLabel() {
      return pluralCount("message.pluralForms.review", this.count);
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-chart-legend-item {
  margin-top: $spacing * 1.25;
  margin-bottom: $spacing * 1.25;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-basis: 300px;
}

.legend-serie {
  max-width: 180px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-shrink: 0;
}

.color-box {
  width: 25px;
  height: 25px;
  margin-right: $spacing * 0.5;
}

.rating-count-wrapper {
  flex: 1;
  padding-left: $spacing * 2;
}

.rating-count {
  @include font-size(14px);
  font-weight: 500;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: #d3d3d3;
  white-space: nowrap;
}
</style>
